<ambita-cadastre-report-selector>
  <form class="ambita-cadastre-report-selector__form" onsubmit="{ formSubmit }">
    <input class="ambita-cadastre-report-selector__cadastre-input"
           if="{ isValidTokenAvailable }" ref="cadastreKeyInput"
           placeholder="<kommunenr>-<gårdsnr>-<bruksnr>-<festenr>-<seksjonsnr>" value="{cadastreKey}"/>
    <input class="ambita-cadastre-report-selector__placeholder" if="{ !isValidTokenAvailable }"
           placeholder="{ i18n.common.loginRequired }" disabled/>
  </form>
  <script>
    import '../../i18n/commonTranslations';
    import './cadastreReportSelector.scss';
    import { init } from './cadastreReportSelectorController';

    init(this);
  </script>
</ambita-cadastre-report-selector>
